import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { CurrentUserPreferencesFacade } from '@recruitee/account-logic';
import { FeatureDiscoveryActions } from '@recruitee/feature-discovery-data';
import { I18nService } from '@recruitee/i18n';
import { BoxComponent, IconButtonComponent } from '@recruitee/user-interface';

import { KiwiHrPromoAnalytics } from '../kiwi-hr-promo.analytics';
import { KiwiHrPromoComponent } from '../kiwi-hr-promo/kiwi-hr-promo.component';

@Component({
  selector: 'rt-kiwi-hr-promo-card',
  template: `
    <rt-box>
      <rt-icon-button
        variant="plain"
        iconName="close"
        size="small"
        (click)="close()"
      ></rt-icon-button>
      <rt-kiwi-hr-promo
        [theme]="theme()!"
        hasBigHeading="false"
        buttonFitContent="false"
        subheadingFontWeight="medium"
        hasPadding="false"
        hasButtonLargeMarginTop="false"
        hasHeadingMarginBottom="false"
        (ctaClick)="openKiwiHr()"
      ></rt-kiwi-hr-promo>
    </rt-box>
  `,
  styleUrl: 'kiwi-hr-promo-card.component.less',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BoxComponent, KiwiHrPromoComponent, IconButtonComponent],
})
export class KiwiHrPromoCardComponent {
  private readonly analytics = inject(KiwiHrPromoAnalytics);

  private readonly i18n = inject(I18nService);

  private readonly store = inject(Store);

  private readonly currentUserPreferencesFacade = inject(CurrentUserPreferencesFacade);

  protected theme = toSignal(this.currentUserPreferencesFacade.effectiveThemeName$);

  public ngAfterViewInit(): void {
    this.analytics.trackBannerDisplay();
  }

  protected close(): void {
    this.analytics.trackBannerClose();
    this.store.dispatch(FeatureDiscoveryActions.update({ payload: { promoteKiwihrClosed: true } }));
  }

  protected openKiwiHr(): void {
    this.analytics.trackBannerCtaClick();
    window.open(this.i18n.translate('rti.kiwi_hr.promo.cta_link'), '_blank');
  }
}
